import { GAME_TYPES_CONFIG } from '../config/gameTypes';
export class GameTypeService {
    static getConfig(gameType) {
        return GAME_TYPES_CONFIG[gameType];
    }
    static getMode(gameType) {
        return this.getConfig(gameType).mode;
    }
    static getNumberWidth(gameType) {
        return this.getConfig(gameType).numberWidth;
    }
    static getNumberHeight(gameType) {
        return this.getConfig(gameType).numberHeight;
    }
    static getHistoricComponent(gameType) {
        const mode = this.getMode(gameType);
        return this.getConfig(gameType).historic;
    }
    static getNumbersGridComponent(gameType) {
        // Verificar si hay un componente especial para este tipo
        if (this.SPECIAL_COMPONENTS[gameType]) {
            return this.SPECIAL_COMPONENTS[gameType].numbersGrid;
        }
        // Usar el componente por defecto del modo
        const mode = this.getMode(gameType);
        return this.getConfig(gameType).numbersGrid;
    }
    // Métodos para obtener componentes directamente (para casos especiales)
    static getHistoricComponentName(gameType) {
        return this.getHistoricComponent(gameType);
    }
    static getNumbersGridComponentName(gameType) {
        return this.getNumbersGridComponent(gameType);
    }
    // Métodos de conveniencia
    static getDisplayName(gameType) {
        return this.getConfig(gameType).displayName;
    }
    static getMaxNumbers(gameType) {
        return this.getConfig(gameType).maxNumbers;
    }
    static getCardImage(gameType) {
        return this.getConfig(gameType).cardImage;
    }
    static getWinImage(gameType) {
        return this.getConfig(gameType).winImage;
    }
    static getPlayerDisplayCells(gameType) {
        return this.getConfig(gameType).playerDisplayCells;
    }
    static getGridSize(gameType) {
        return this.getConfig(gameType).gridSize;
    }
    // Métodos para filtrado
    static getByMode(mode) {
        return this.getAllConfigs().filter(config => config.mode === mode);
    }
    static getAllConfigs() {
        return Object.values(GAME_TYPES_CONFIG);
    }
    static getAllowedGameTypes() {
        return this.getAllConfigs().filter(config => config.allowedInAccounts);
    }
    // Mapeo entre propiedades de AllowedGames y GameType
    static getAllowedGamesMapping() {
        return {
            bingo90: 'Bingo90',
            bingo75: 'Bingo75',
            bingoMex: 'BingoMex',
            bingoAnimals: 'BingoAnimals',
            bingoCartoon: 'BingoCartoon',
            movies: 'Movies',
            moviesKids: 'MoviesKids',
            xmas: 'XMas',
            football: 'Football',
            halloween: 'Halloween',
            superheroes: 'Superheroes',
            cartoon: 'Cartoon',
            music: 'Music',
            canary: 'Canary',
            musicReggaeton: 'MusicReggaeton',
            bingoDominicano: 'BingoDominicano',
            bingoIberostar: 'BingoIberostar',
            musicWinterEnglish: 'MusicWinterEnglish',
            musicWinterSpanglish: 'MusicWinterSpanglish',
            bingoGloriaMusicos: 'BingoGloriaMusicos',
            bingoGloriaLuchadores: 'BingoGloriaLuchadores',
            bingoGloriaChavo: 'BingoGloriaChavo',
            bingoGloriaActors: 'BingoGloriaActors',
            calamarGame: 'CalamarGame',
            calamarIcons: 'CalamarIcons',
            squidGames: 'SquidGames',
            bingoFifa26: 'BingoFifa26',
            bingoJugadoresFifa26: 'BingoJugadoresFifa26'
        };
    }
}
// Mapeo de componentes por modo para evitar duplicación
GameTypeService.MODE_COMPONENTS = {
    classic: {
        historic: 'GameHistoric',
        numbersGrid: 'NumbersGrid'
    },
    cards: {
        historic: 'GameMexHistoric',
        numbersGrid: 'BingoMexNumbersGrid'
    },
    sound: {
        historic: 'GameMusicHistoric',
        numbersGrid: 'BingoMusicNumbersGrid'
    }
};
// Componentes especiales que no siguen el patrón del modo
GameTypeService.SPECIAL_COMPONENTS = {
    'Bingo75': {
        numbersGrid: 'Bingo75NumbersGrid'
    }
};
